import { render, staticRenderFns } from "./newReport2.vue?vue&type=template&id=6e37158c&scoped=true&"
import script from "./newReport2.vue?vue&type=script&lang=js&"
export * from "./newReport2.vue?vue&type=script&lang=js&"
import style0 from "./newReport2.vue?vue&type=style&index=0&id=6e37158c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e37158c",
  null
  
)

export default component.exports